<template>
  <div>
    <v-list class="elevation-2">
      <v-list-tile v-if="items.length" v-for="(item, index) in items" :key="`movement-${item.type}-${item.id}`">
        <v-list-tile-content>
          <v-layout justify-center align-center class="w-100" fill-height>
            <v-flex xs12 @click="showDetails(item.type, item.id)">
              <v-layout justify-center align-center fill-height>
                <v-flex xs3 text-xs-center>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-avatar
                        size="45"
                        class="transparent"
                      >
                        <v-icon large class="k-orange-linear-text">fas fa-money-bill-wave</v-icon>
                      </v-avatar>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs3>
                  <v-layout row wrap>
                    <v-flex xs12>
                      Registrado
                    </v-flex>
                    <v-flex xs12>
                      <small>{{ formatDate(item.register_date, 'YYYY-MM-DD', 'DD/MM/YYYY') }}</small>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs3>
                  <v-layout row wrap>
                    <v-flex xs12>
                      Pagado
                    </v-flex>
                    <v-flex xs12>
                      <small>{{ formatDate(item.payment_date, 'YYYY-MM-DD', 'DD/MM/YYYY') }}</small>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs3>
                  <v-layout row wrap>
                    <v-flex xs12>
                      Referencia
                    </v-flex>
                    <v-flex xs12>
                      <small>#{{ item.reference }}</small>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs3>
                  <v-layout row wrap>
                    <v-flex xs12 class="title">
                      ${{ new Intl.NumberFormat('es-VE').format(item.amount) }}
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-divider v-if="index !== (items.length - 1)"></v-divider>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
import moment from 'moment';
import showRightDrawer from '@/components/global/ShowRightDrawer';
import EventBus from '@/event-bus';

export default{
  components: {
    ShowRightDrawer: showRightDrawer,
  },
  props: ['items'],
  data() {
    return {
      movementDetail: '',
      title: '',
      fields: '',
      over: false,
    };
  },
  methods: {
    showDetails(type, id) {
      const url = `/${type}s`;
      if (type === 'invoice') {
        this.fields = 'reference,date,number,control,due_date,expires_date,descrip,amount,tax,total,balance';
        this.movementDetail = 'invoiceDetail';
        this.title = 'Detalles de la factura';
      } else {
        this.fields = 'paymentMethod.name,invoice.balance,invoice.expires_date,invoice.total,invoice.descrip,files.name,files.original_name,date,amount,currency,reference,internal_ref,descrip,code,batch,recipient,remote_ip';
        this.movementDetail = 'paymentDetail';
        this.title = 'Detalles del pago';
      }
      EventBus.$emit('detail', id, url, this.fields);
    },
    payInvoice(invoice) {
      EventBus.$emit('get-invoice', invoice);
    },
    formatDate(date, typeFormat, toFormat) {
      return moment(date, typeFormat).format(toFormat);
    },
  },
};

</script>

<style>
.w-100{
  width: 100%;
}
.list{
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/MovementList.vue